import { Injectable, Signal, computed, inject } from '@angular/core';

import { MenuStore } from '@core/menu';
import { SkinningService } from '@core/skin';

// Thin shim that lets the existing MainLayout/header bindings stay on
// `homepageService.menuItems` while the data is sourced from the new V1
// MenuStore (/api/v1/menu). Move callers to inject MenuStore directly when
// you next touch them; this service can then be deleted.

@Injectable({ providedIn: 'root' })
export class HomepageService {
    public readonly skinning = inject(SkinningService);
    private readonly menu = inject(MenuStore);

    public readonly menuItems: Signal<unknown[]> = computed(() => this.menu.items());
}
